import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {WkfSupervisionSearchItemsState} from './reducer/wkf-supervision-search-items.reducer';

export const selectWkfSupervisionSearchItemsFeature = createFeatureSelector<WkfSupervisionSearchItemsState>(StoreKeys.WKF_SUPERVISION_SEARCH_ITEMS);

export const selectWkfSupervisionSearchItemsDatas = createSelector(selectWkfSupervisionSearchItemsFeature, state => state.datas);
